<template>
    <div id="report-view">
        <report-load v-if="!reportLoaded && !error"></report-load>
        <div class="mt-3" v-if="!reportLoaded && error">{{ error }} <a href="#" @click.prevent="refresh">Retry now?</a></div>
        <div v-if="reportLoaded">
            <report-summary v-bind:report="report" v-bind:revenue="revenue" v-bind:enrolled="enrolled" v-bind:cancelled="cancelled" v-bind:active="active" v-bind:eligible="eligible" v-bind:activePercentage="activePercentage"></report-summary>
            <report-month v-bind:report="report" v-bind:year="year" v-bind:monthName="monthName" v-bind:revenue="revenue" v-bind:enrolled="enrolled" v-bind:cancelled="cancelled" v-bind:active="active"></report-month>
            <report-services v-bind:client="client" v-bind:year="year" v-bind:month="month" v-bind:monthName="monthName" v-bind:report="report"></report-services>
            <report-page-feedback v-bind:year="year" v-bind:month="month" v-bind:monthName="monthName" v-bind:feedback="report.services.pagefeedback"></report-page-feedback>
            <report-enrolment-profile v-if="enrolled.all_inclusive" v-bind:enrolled="enrolled" v-bind:year="year" v-bind:month="month" v-bind:monthName="monthName" v-bind:report="report"></report-enrolment-profile>
            <report-cancellation-profile v-if="cancelled.month_never_used" v-bind:cancelled="cancelled" v-bind:year="year" v-bind:month="month" v-bind:monthName="monthName" v-bind:report="report"></report-cancellation-profile>
            <div class="mt-5">
                <export-audit v-bind:client_id="client_id" v-bind:month="month" v-bind:year="year"></export-audit>
                <a class="ml-1 btn btn-sm btn-secondary" v-bind:href="'/admin/reports/export/configure/' + client_id + '/' + year + '/' + month">Configure Export</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReportView",
        props: ['client_id', 'month', 'year','monthName'],
        data() {
            return {
                reportLoaded: false,
                client: null,
                report: null,
                revenue: null,
                enrolled: null,
                active: null,
                cancelled: null,
                eligible: 0,
                activePercentage: 0,
                error: "",
            }
        },
        mounted() {
            this.getReport();
        },
        methods: {
            getReport() {
                this.error = "";
                axios.post('/admin/reports/report/data/' + this.client_id, {
                    month: this.month,
                    year: this.year
                })
                    .then(response => {

                        if(response.data.loading){
                            this.error = "The report is still being built, retrying in 10 seconds.";
                            setTimeout(() => {
                                this.getReport();
                            }, 5000);
                        } else {
                            this.report = response.data.report;
                            this.reportLoaded = true;
                        }

                    }).catch(error => {
                    if(error.response.status === 404){
                        this.error = "Report not found.";
                    }
                    if(error.response.status === 500){
                        this.error = "We encountered a problem whilst fetching the report.";
                    }
                });
            },
            refresh() {
                this.getReport();
            }
        },
        watch: {
            report(){
                this.revenue = JSON.parse(this.report.revenue);
                this.enrolled = JSON.parse(this.report.enrolled);
                this.active = JSON.parse(this.report.active);
                this.cancelled = JSON.parse(this.report.cancelled);
                this.eligible = this.enrolled.all - this.cancelled.all;
                let percentage = this.active.current/this.eligible*100;
                if(isFinite(percentage)){
                    percentage = '(' + percentage.toFixed(0) + '% of Eligible Customers)';
                } else {
                    percentage = "Customers";
                }
                this.activePercentage = percentage;
            }
        },
    }
</script>

<style scoped>
</style>
